// Angular
import { Injectable } from "@angular/core";

@Injectable()
export class BetAmountService {

  // 3, 4, 200,
  betAmounts: number[] = [0.1, 0.20, 0.5, 1, 2, 5, 10, 20, 50, 100, 500, 1000];
  showBetAmounts: number[] = [];
  minBet!: number;
  maxBet!: number;

  constructor(
  ) {}

  /**
   * Get bet amounts
   * @param {any[]} pool current pools
   * @returns {any[]} amounts
   */
  getBetAmounts(pool: any): {
    showBetAmounts: number[],
    minBet: number
  } {

    if (this.showBetAmounts.length > 0)
      this.showBetAmounts = [];

    if (pool !== undefined) {
      this.minBet = pool.WagerMinimum;
      this.maxBet = pool.WBMaximum;

      this.betAmounts.forEach((amount)=>{
        if(
            (
              (
                !pool.Multiple &&
                amount >= pool.MultipleBetMinimum &&
                amount <= pool.WBMaximum
              ) ||
              (
                pool.Multiple &&
                amount >= pool.MultipleBetMinimum &&
                amount <= pool.WBMaximum &&
                (
                  (amount * 100) % (pool.MultipleBetMinimum * 100)
                ) === 0
              )
            ) || amount == 0.001
          )
        {
          this.showBetAmounts.push(amount);
        }
      });

      this.minBet = this.showBetAmounts[0];
    }

    return {
      showBetAmounts: this.showBetAmounts,
      minBet: this.minBet,
    };
  }
}
